export const PRIMARY_COLOR = "#0B314E";
export const PRIMARY_COLOR_HOVER = "#849909";
export const SECONDARY_COLOR = "#731DD8";
export const SECONDARY_COLOR_HOVER = "#731DD8";
// export const VERDE = "#ADC852";
// export const BLANCO = "#FFFFFF";
// export const GRIS_CLARO = "#BDBDBD";
